module.exports = __webpack_public_path__ + "img/baise.75a31a0a.png";